export default __webpack_public_path__ + "static/media/il.35b8b5b8.svg";